import React, { useState, useEffect, Component } from 'react';
import axios from 'axios';
import Table from 'react-bootstrap/Table';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import { PDFDownloadLink, PDFViewer, Page, View, Text, Document, StyleSheet } from '@react-pdf/renderer';
import TableView from './TableView';

function PDFGenerator() {
    const [baseUrl, setBaseUrl] = useState('http://mol.evolve-demo.com/api/');
    const [pageComponent, setPageComponent] = useState('vessels');
    const [data, setData] = useState([]);
    // const [data, setData] = useState(undefined);

    // const data = [
    //     { name: 'John Doe', email: 'john@example.com' },
    //     { name: 'Jane Smith', email: 'jane@example.com' },
    //     // Add more objects as needed
    // ];

    // useEffect(() => {
    //     fetch(`${baseUrl}${pageComponent}/index`)
    //         .then(response => response.json())
    //         .then(data => {
    //             setData(data.vessels);
    //         })
    //         .catch(error => {
    //             console.error(error);
    //         });
    // }, []);

    useEffect(() => {
        fetch(`${baseUrl}reports/2023-06-07 00:00:00/2023-06-16 04:05:00/jobtypewiserevenuereport`)
            .then(response => response.json())
            .then(data => {
                setData(data.job_type_wise_revenue);
            })
            .catch(error => {
                console.error(error);
            });
    }, []);

    const columns = ['BookingNo', 'BLNo', 'TotalVolume', 'TotalQuote', 'TotalCost', 'Difference'];

    const styles = StyleSheet.create({
        // page: { backgroundColor: 'tomato' },
        // section: { color: 'white', textAlign: 'center', margin: 30 },
        table: {
            display: "table",
            width: "auto",
            borderStyle: "solid",
            borderWidth: 1,
            borderRightWidth: 0,
            borderBottomWidth: 0
        },
        tableRow: {
            margin: "auto",
            flexDirection: "row"
        },
        tableCol: {
            width: "20%",
            borderStyle: "solid",
            borderWidth: 1,
            borderLeftWidth: 0,
            borderTopWidth: 0
        },
        tableCell: {
            margin: "auto",
            marginTop: 5,
            fontSize: 10
        }

    });



    const MyDocument = () => (
        <Document>
            <Page style={styles.body}>
                <View style={styles.table}>
                    <View style={styles.tableRow}>
                        {columns.map(column => (
                            <View style={styles.tableCol} key={column}>
                                <Text style={styles.tableCell}>{column}</Text>
                            </View>
                        ))}
                    </View>
                    {data.map(row => (
                        <View style={styles.tableRow} key={row.id}>
                            {columns.map(column => (
                                <View style={styles.tableCol} key={column}>
                                    <Text style={styles.tableCell}>{row[column]}</Text>
                                </View>
                            ))}
                        </View>
                    ))}
                </View>
            </Page>
        </Document>
    );

    return (
        <div>
            <PDFDownloadLink document={<MyDocument />} fileName="document.pdf">
                {({ blob, url, loading, error }) =>
                    loading ? 'Loading...' : 'Download PDF'
                }
            </PDFDownloadLink>
        </div>
    );
};

export default PDFGenerator;
